import { ArmsCushionsPanel } from '@components/ArmsCushionsPanel'
import { ArmRestrictionNoticeModal } from '@components/ArmsCushionsPanel/ArmRestrictionNoticeModal'
import { BudgetPreviewModal } from '@components/Budget/BudgetPreviewModal'
import { Toolbar } from '@components/Toolbar/export'
import { TexturesPanel } from '@components/Viewer3D/TexturesPanel'
import { SelectedUnitInfo } from '@components/Viewer3D/SelectedUnitInfo'
import { useFetchMenu } from '@hooks/useFetchMenu'
import { useAppStore } from '@store'
import { useState } from 'react'
import { CompactTopbar } from './CompactTopbar'
import { ModeBar } from './ModeBar'
import { ActiveSheetHost } from './SheetHost'
import { MoreActionsSheet, TouchActionBar } from './TouchActionBar'

/**
 * Chrome para tablet y móvil:
 * Canvas protagonista + mode bar + bottom sheets.
 * Desktop no usa este componente.
 *
 * Opciones (paso 2) solo se abre desde ModeBar — no al seleccionar/duplicar.
 */
export function TouchChrome() {
  const currentObjectID = useAppStore.use.currentObjectID()
  const currentLayer = useAppStore.use.currentLayer()
  const layers = useAppStore.use.layers()
  const items = useAppStore.use.items()
  const selectedItems = layers[currentLayer]?.selected || new Set()
  const [showBudgetPreview, setShowBudgetPreview] = useState(false)

  const { menuData: armsMenuData } = useFetchMenu('PRINCIPAL', 'PRINCIPAL', null)
  const { menuData: relaxMenuData } = useFetchMenu('RELAXMENU', 'RELAXMENU', null)

  return (
    <>
      <CompactTopbar />

      <div className='pointer-events-none fixed left-3 top-14 z-[65] max-w-[min(100%-6.5rem,280px)]'>
        <div className='pointer-events-auto'>
          <SelectedUnitInfo
            items={items}
            selectedItems={selectedItems}
            currentObjectID={currentObjectID}
          />
        </div>
      </div>

      <TouchActionBar onOpenBudget={() => setShowBudgetPreview(true)} />
      <ModeBar />

      <ActiveSheetHost>
        {(sheet) => {
          if (sheet === 'modules') return <Toolbar presentation='embedded' />
          if (sheet === 'textures') return <TexturesPanel presentation='embedded' />
          if (sheet === 'options') {
            return (
              <div className='p-2 pb-6'>
                <ArmsCushionsPanel
                  presentation='embedded'
                  menuData={armsMenuData}
                  relaxMenuData={relaxMenuData}
                />
              </div>
            )
          }
          return <MoreActionsSheet onOpenBudget={() => setShowBudgetPreview(true)} />
        }}
      </ActiveSheetHost>

      <BudgetPreviewModal
        open={showBudgetPreview}
        onClose={() => setShowBudgetPreview(false)}
      />
      <ArmRestrictionNoticeModal />
    </>
  )
}
